<template>
  <div>
    <v-row>
      <template v-if="loading_folders">
        <v-col md="4" v-for="(i, index) in 3" :key="'skeleton-' + index">
          <CardSkeletonList />
        </v-col>
      </template>
      <template v-else>

        <v-col v-for="(folder, index) in folderData.sub_folder" :key="'folder-' + index" cols="12" sm="6" md="3">
          <CardFolder :folder="folder" @click="$emit('open-folder', folder)" @editItem="$emit('editItem', folder)"
            @deleteItem="$emit('deleteItem', folder)" :legajo_id="legajo_id"/>
        </v-col>

        <v-col v-for="(file, index) in folderData.documents" :key="'file-' + index" cols="12" sm="6" md="3">
          <CardFile :file="file" @deleteItemFile="$emit('deleteItemFile', file)" />
        </v-col>
        <ListEmpty
          v-if="(!folderData.sub_folder || !folderData.sub_folder.length) && (!folderData.documents || !folderData.documents.length)" title="Aun no existen documentos en esta carpeta" description="Crea una carpeta o un nuevo documento para comenzar a organizar tus archivos." />
      </template>
    </v-row>
  </div>
</template>


<script>
import CardFile from './CardFile.vue';
import CardFolder from './CardFolder.vue'
import ListEmpty from './ListEmpty.vue';
import CardSkeletonList from '../CardSkeletonList.vue';

export default {

  name: 'ListFile',
  components: {
    CardFolder,
    CardFile,
    ListEmpty,
    CardSkeletonList
  },
  props: {
    legajo_id: {
      type: [Number, String],
      default: null
    },
    folderData: {
      type: Object,
      required: true
    },
    editItem: {
      type: Function,
      default: () => { }
    },
    deleteItem: {
      type: Function,
      default: () => { }
    },
    deleteItemFile: {
      type: Function,
      default: () => { }
    },
    loading_folders: {
      type: Boolean,
      default: false
    }
  }
}
</script>
